var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSixthSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 202,
    viewBox: "0 0 118 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4912 105.51C48.4912 105.51 50.8302 150.139 52.0024 159.184C53.1746 168.228 55.5136 181.423 55.5136 181.423C55.5136 181.423 53.8413 182.595 53.508 183.768C53.1746 184.94 53.6746 189.285 53.6746 189.285L65.8804 190.118C65.8804 190.118 66.3805 187.112 66.3805 180.251V170.035C66.3805 168.701 68.3915 111.51 68.3915 111.51L69.8917 170.207C69.8917 170.207 69.3916 188.43 70.2304 188.763C71.056 189.19 71.8392 189.694 72.5694 190.269L83.2696 189.935C83.7229 187.958 84.0035 185.944 84.1084 183.918C84.1084 181.574 82.6029 177.062 82.7696 174.551C82.9363 172.04 87.2863 151.645 87.2863 148.134V93.4648H48.8353L48.4912 105.51Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7066 189.293C64.7066 189.293 60.1953 185.449 58.1897 185.782C56.184 186.116 54.3397 187.288 54.173 187.788C54.0064 188.288 52.8342 189.293 52.5008 190.294C52.1674 191.294 46.8173 196.316 45.6451 197.655C44.4729 198.994 43.6395 199.16 44.645 199.994C45.2673 200.502 46.0065 200.848 46.7958 200.999H65.8788C65.8788 200.999 66.5509 199.494 66.3788 196.483C66.2068 193.471 65.8788 190.127 65.8788 190.127L64.7066 189.293Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2012 199.324C44.2012 199.518 44.3195 199.717 44.6475 199.991C45.2698 200.5 46.009 200.845 46.7983 200.996H65.8812C66.0848 200.458 66.2203 199.896 66.2845 199.324H44.2012Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6394 189.293C72.6394 189.293 76.8926 185.449 78.7853 185.782C80.678 186.116 82.4094 187.288 82.5492 187.788C82.689 188.288 83.8074 189.293 84.1247 190.294C84.4419 191.294 89.5017 196.316 90.5771 197.655C91.6525 198.994 92.4698 199.16 91.5234 199.994C90.9402 200.502 90.2338 200.849 89.4748 200.999H71.5156C71.5156 200.999 70.8865 199.494 71.0424 196.483C71.1984 193.471 71.5156 190.127 71.5156 190.127L72.6394 189.293Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9633 199.324C91.9633 199.518 91.8504 199.717 91.5439 199.991C90.9606 200.499 90.2543 200.846 89.4952 200.996H71.5361C71.3446 200.456 71.2165 199.895 71.1543 199.324H91.9633Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5834 33.5195L57.7441 37.6276L58.6152 94.3882H79.5264C79.5264 94.3882 80.5211 36.3801 80.1501 35.5091C79.7791 34.638 77.5369 33.7669 77.5369 33.7669L62.5834 33.5195Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0501 58.2514L106.368 60.5528C106.368 60.5528 97.9426 45.099 96.4101 41.3942C95.2111 38.5014 93.7216 37.6303 93.1033 37.3991C89.9147 35.3396 77.5422 33.7695 77.5422 33.7695L76.5744 62.1122L75.0957 109.151H92.6946C92.6946 109.151 91.2106 92.5411 90.3933 87.2769L89.2372 79.8727C89.2372 79.8727 90.6621 68.5808 91.9257 57.7675L98.0501 58.2514Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4856 69.4258C78.9424 70.8492 78.2579 72.2147 77.4424 73.5016",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1348 35.5156L83.0599 42.0273L80.6563 44.6352L84.4633 49.2433C84.4633 49.2433 82.9792 59.2824 80.3606 67.0576",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1529 19.7588C61.1529 19.7588 59.5882 17.6079 58.4644 19.1511C57.3407 20.6944 61.5939 26.0231 61.5939 26.0231L61.1529 19.7588Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2476 19.7588C79.2476 19.7588 80.8123 17.6079 81.9361 19.1511C83.0599 20.6944 78.8066 26.0231 78.8066 26.0231L79.2476 19.7588Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8039 18.5537C60.8039 18.5537 61.761 28.5551 61.9385 30.2973C62.1159 32.0395 62.7181 35.7765 63.4172 37.0778C64.1162 38.379 68.8963 43.2561 70.1976 42.7345C71.4988 42.2129 76.0262 37.5133 77.2468 36.1207C78.4674 34.728 78.0265 32.2061 78.2039 31.5985C78.3813 30.9909 79.0696 24.9901 79.0696 24.9901L79.4836 18.6559C79.4836 18.6559 79.6611 18.0483 79.3976 14.1338C79.1341 10.2192 79.1395 8.47706 78.704 7.51994C78.2684 6.56281 77.1393 6.04124 75.1336 5.51966C73.128 4.99808 68.3532 5.08949 65.3959 6.56819C62.4385 8.04689 60.9599 10.1332 60.8738 10.9129C60.7878 11.6926 60.8039 18.5537 60.8039 18.5537Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8107 15.6678C68.8107 15.6678 66.1222 13.9257 64.6328 16.2055",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5459 15.8289C73.1163 15.4821 73.7864 15.3365 74.4493 15.4155C75.1121 15.4944 75.7293 15.7934 76.2023 16.2644",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7674 16.707C72.1262 17.3667 72.3113 18.1069 72.3051 18.8579C72.3911 20.4226 72.1277 23.6381 72.1277 23.6381L68.8262 23.2886",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0674 24.4688C67.0674 24.4688 68.7181 27.1573 72.896 25.77",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5891 18.2422C67.5891 18.7477 67.3579 19.1563 67.0514 19.1563C66.7449 19.1563 66.5137 18.7477 66.5137 18.2422C66.5137 17.7368 66.7503 17.3281 67.0514 17.3281C67.3525 17.3281 67.5891 17.7368 67.5891 18.2422Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9836 18.2422C74.9836 18.7477 74.7524 19.1563 74.4459 19.1563C74.1394 19.1563 73.9082 18.7477 73.9082 18.2422C73.9082 17.7368 74.1394 17.3281 74.4459 17.3281C74.7524 17.3281 74.9836 17.7368 74.9836 18.2422Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2893 19.4219C67.6003 20.0728 66.7649 20.5486 65.8535 20.8092",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4189 19.4219C73.4189 19.4219 74.4621 20.6371 75.6827 20.8092",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1543 32.8125C67.1543 32.8125 68.8104 34.8128 73.4185 32.8985",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8521 10.3657C59.8521 10.3657 60.1102 19.1519 60.3898 19.3239C60.6694 19.496 61.4329 19.6734 61.605 19.0658C61.7125 18.1127 61.7412 17.1523 61.691 16.1945C61.691 16.1945 62.5621 16.1084 62.7341 14.7158C62.9062 13.3231 62.1265 10.8873 62.1265 10.8873C62.1265 10.8873 65.2559 8.62889 68.2133 7.7578C71.1706 6.88672 72.7407 8.19335 74.5635 8.29551C75.6342 8.35625 76.6889 8.0149 77.5209 7.33839C77.5209 7.33839 76.6498 8.64502 76.6498 9.25264C76.6498 9.86025 77.7844 13.0811 77.6069 14.0382C77.4295 14.9954 77.2628 16.0385 77.7843 16.3827C78.3059 16.7268 78.9135 17.1677 78.9135 17.1677C78.9135 17.1677 78.9135 19.5175 79.263 19.6896C79.6125 19.8616 80.2201 18.9099 80.3062 17.6033C80.3922 16.2966 80.3922 13.1672 80.8439 12.2262C81.2955 11.2852 81.973 10.5754 81.4515 9.18273C80.9299 7.79007 79.1017 6.57485 78.8436 6.49419C78.5855 6.41353 75.2787 2.1495 71.0147 1.1171C66.7507 0.0847009 59.9704 6.16619 59.2713 8.08043C58.5723 9.99467 59.8521 10.3657 59.8521 10.3657Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4712 41.2334C20.9787 40.0102 20.5779 38.7521 20.2721 37.4695C20.0839 36.2704 18.6052 34.3293 17.1319 33.7754C15.5402 33.1605 14.1161 32.1786 12.9755 30.9094C11.6796 29.5275 10.943 29.0651 10.7548 30.447C10.5666 31.8289 11.4968 32.4795 12.4217 33.313C13.3465 34.1464 14.266 34.8831 14.266 34.8831C13.3393 35.1835 12.378 35.3642 11.4054 35.4208C9.69837 35.5049 7.98797 35.3493 6.32416 34.9584C4.93689 34.5874 0.135229 31.0815 0.597651 32.4634C1.06007 33.8453 3.36681 35.6036 5.2165 37.3619C7.06618 39.1202 8.26525 40.0505 10.3892 40.685C12.5131 41.3195 15.9275 42.1637 15.9275 42.1637L17.8686 44.75L21.4712 41.2334Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15913 38.7426C7.15913 38.7426 4.20178 36.5272 3.73936 34.0323C3.27693 31.5373 3.46513 30.6178 4.11037 30.9835C4.75561 31.3491 6.32569 34.9571 6.32569 34.9571L9.09484 38.0059",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15913 38.7426C7.15913 38.7426 4.20178 36.5272 3.73936 34.0323C3.27693 31.5373 3.46513 30.6178 4.11037 30.9835C4.75561 31.3491 6.32569 34.9571 6.32569 34.9571L9.09484 38.0059",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64713 39.9431C9.64713 39.9431 6.87799 38.2762 6.60376 36.6147C6.32953 34.9532 5.67891 30.06 6.32415 30.4257C6.96939 30.7913 8.26525 35.9695 8.26525 35.9695L9.83533 37.3568",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64713 39.9431C9.64713 39.9431 6.87799 38.2762 6.60376 36.6147C6.32953 34.9532 5.67891 30.06 6.32415 30.4257C6.96939 30.7913 8.26525 35.9695 8.26525 35.9695L9.83533 37.3568",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1959 40.0303C11.1959 40.0303 9.53436 36.804 9.16335 35.7824C8.79234 34.7608 7.96428 30.5182 8.79771 30.701C9.63115 30.8839 10.3678 35.1318 10.3678 35.1318L12.4917 37.8203C12.4917 37.8203 15.4437 36.8955 16.2556 37.0783C17.0675 37.2611 18.1053 38.928 18.1053 38.928",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1959 40.0303C11.1959 40.0303 9.53436 36.804 9.16335 35.7824C8.79234 34.7608 7.96428 30.5182 8.79771 30.701C9.63115 30.8839 10.3678 35.1318 10.3678 35.1318L12.4917 37.8203C12.4917 37.8203 15.4437 36.8955 16.2556 37.0783C17.0675 37.2611 18.1053 38.928 18.1053 38.928",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6657 42.6932L21.4557 40.6445L15.998 46.3389L17.6004 48.4413L23.6657 42.6932Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5851 33.5195C62.5851 33.5195 60.7139 48.328 60.4665 56.797C60.2192 65.2659 61.0903 109.702 61.0903 109.702L44.5345 109.202C44.5345 109.202 46.4003 93.5171 47.7607 87.7905C48.6962 83.3748 49.0309 78.853 48.7554 74.3478C48.6318 73.6003 47.7607 66.7553 47.7607 66.7553C47.7607 66.7553 38.4208 72.9766 37.3024 72.8529C36.184 72.7293 29.7101 68.0136 24.731 61.7761C21.5645 57.6853 19.0072 53.1574 17.1387 48.3334L23.0265 41.6067L36.969 55.5495C36.969 55.5495 44.185 40.9883 44.9324 40.6119C45.6798 40.2355 62.5851 33.5195 62.5851 33.5195Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.708 59.125C56.614 63.9492 57.9124 68.6914 59.5902 73.3044",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4062 36.0156L56.395 43.635L58.8039 45.6406L54.5938 50.0498C54.6929 52.3228 54.9335 54.5873 55.3143 56.8303",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3932 64.7617C47.3932 64.7617 44.9036 53.8086 44.167 49.4531L47.3932 64.7617Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3932 64.7617C47.3932 64.7617 44.9036 53.8086 44.167 49.4531",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3145 41.9844L64.4384 48.2164L70.2025 42.7264L74.7783 48.6412L76.784 43.3233",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3145 41.9844L64.4384 48.2164L70.2025 42.7264L74.7783 48.6412L76.784 43.3233",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4182 45.9474L69.8158 50.5932L66.8262 45.9152L70.2029 42.7266L72.4182 45.9474Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8169 50.5938L64.0205 89.4056L69.1878 93.5621L73.2206 89.2819L69.8169 50.5938Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8453 34.8242C96.9768 33.8423 99.53 29.6969 98.548 25.5654C97.5661 21.4338 93.4208 18.8806 89.2893 19.8626C85.1578 20.8446 82.6046 24.9899 83.5866 29.1215C84.5686 33.253 88.7139 35.8062 92.8453 34.8242Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0177 37.2428C86.0177 37.2428 85.7543 40.6841 85.9532 41.3455C86.1522 42.0069 87.5663 44.6524 87.5663 44.6524C87.5663 44.6524 87.3674 46.5075 87.6954 47.1043C88.0234 47.7012 91.2012 51.4705 91.2012 51.4705L94.9651 48.1583L92.8304 43.9211L92.7659 38.4311C92.7659 38.4311 88.6256 34.8661 86.0177 37.2428Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8887 33.4475L89.0501 42.9918C89.1146 43.4775 89.367 43.9185 89.753 44.2201C90.1391 44.5217 90.628 44.6599 91.1149 44.6049C91.5834 44.5524 92.0148 44.3249 92.3228 43.968C92.6309 43.6111 92.7928 43.1511 92.7764 42.6799L92.443 32.9313C92.443 32.9313 89.5717 30.7751 87.8887 33.4475Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0887 35.5195C88.0887 35.5195 85.6152 35.8153 85.6152 36.5949C85.6152 37.3746 86.5024 40.9504 87.2929 41.1493C88.0833 41.3483 88.6801 41.3483 88.6801 39.7621C88.5993 38.3341 88.4014 36.9152 88.0887 35.5195Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9255 38.1953C93.9255 38.1953 88.1829 38.69 88.0861 39.2707C87.9893 39.8515 88.1829 41.3517 88.5808 41.3517C88.9787 41.3517 94.1191 41.3893 94.2213 40.814C94.3235 40.2386 94.6192 38.9857 93.9255 38.1953Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7506 40.9844C93.7506 40.9844 88.6371 41.2694 88.5295 41.7963C88.422 42.3233 88.5618 43.646 88.9167 43.6568C89.2716 43.6675 93.8366 43.8396 93.9442 43.3395C94.0517 42.8395 94.3475 41.7049 93.7506 40.9844Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0497 43.4688C93.0497 43.4688 88.8127 43.7053 88.7481 44.1409C88.6836 44.5764 88.775 45.6734 89.0707 45.6841C89.3665 45.6949 93.1411 45.8347 93.2272 45.4206C93.3132 45.0066 93.5444 44.0656 93.0497 43.4688Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M93.53 35.6133C93.53 35.6133 87.7874 36.108 87.6906 36.6887C87.5938 37.2694 87.7874 38.7642 88.1853 38.7642C88.5832 38.7642 93.7236 38.8073 93.8258 38.2265C93.9279 37.6458 94.2237 36.3822 93.53 35.6133Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8725 46.2768L93.2057 45.4219L88.6836 50.9657L90.5387 53.4391L94.8725 46.2768Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5412 45.2969C94.5412 45.2969 92.8958 49.1307 91.6645 50.5019C90.4332 51.8731 89.0566 53.1044 89.0566 53.1044C89.0566 53.1044 94.81 66.6708 95.6166 69.2733C96.4231 71.8758 99.5902 73.6556 100.961 74.0643C102.332 74.473 105.618 73.3814 106.876 72.0103C108.134 70.6391 109.887 66.2568 108.93 63.7941C107.973 61.3314 94.5412 45.2969 94.5412 45.2969Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M103.966 37.5539C111.404 35.629 115.873 28.0393 113.948 20.6018C112.023 13.1642 104.433 8.69534 96.9959 10.6202C89.5585 12.5451 85.0897 20.1348 87.0145 27.5723C88.9393 35.0098 96.5289 39.4787 103.966 37.5539Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M103.031 35.1154C109.13 33.705 112.931 27.6174 111.521 21.5182C110.111 15.4191 104.023 11.618 97.9242 13.0284C91.8251 14.4387 88.0242 20.5264 89.4345 26.6255C90.8448 32.7247 96.9324 36.5257 103.031 35.1154Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3854 29.2378C101.924 29.2378 103.983 27.1795 103.983 24.6404C103.983 22.1013 101.924 20.043 99.3854 20.043C96.8464 20.043 94.7881 22.1013 94.7881 24.6404C94.7881 27.1795 96.8464 29.2378 99.3854 29.2378Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.012 24.0902C103.013 23.588 102.866 23.0968 102.587 22.6787C102.309 22.2607 101.913 21.9345 101.449 21.7416C100.986 21.5487 100.475 21.4977 99.9826 21.595C99.49 21.6923 99.0372 21.9336 98.6818 22.2883C98.3263 22.6431 98.084 23.0953 97.9857 23.5877C97.8873 24.0802 97.9373 24.5908 98.1292 25.0549C98.3211 25.5189 98.6464 25.9156 99.0639 26.1947C99.4814 26.4739 99.9723 26.6228 100.474 26.6228C101.147 26.6228 101.791 26.3562 102.267 25.8814C102.743 25.4066 103.011 24.7624 103.012 24.0902Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 0.4225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixthSlide);
export default __webpack_public_path__ + "static/media/sixthSlide.4c8d8cd37538e75d41c876d7ff95e5cf.svg";
export { ForwardRef as ReactComponent };